import React, { Context } from 'react';

const { createContext, useContext } = React;

let ThemeContext: Context<string> = createContext<string>('default-theme');

export const useTheme = (): string => {
  return useContext<string>(ThemeContext);
};

interface Props {
  theme: string;
  children: any;
}

export const ThemeProvider = ({ theme, children }: Props) => (
  <ThemeContext.Provider value={theme} children={children} />
);
